var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXlsx(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M18 7h-2.5c-.827 0-1.5-.673-1.5-1.5V2H6v16h12V7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M18 6l-3-3.293V5.5c0 .275.225.5.5.5H18z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    fill: "#605E5C",
    d: "M18.707 5.293l-3.707-4A1 1 0 0014.293 1H6a1 1 0 00-1 1v16a1 1 0 001 1h12a1 1 0 001-1V6a1 1 0 00-.293-.707zM18 6h-2.5a.501.501 0 01-.5-.5V2.707L18 6zM6 17.8V2.2c0-.11.09-.2.2-.2H14v3.5A1.5 1.5 0 0015.5 7H18v10.8a.2.2 0 01-.2.2H6.2a.2.2 0 01-.2-.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#134A2C",
    d: "M16.5 12h-1c-.275 0-.5.225-.5.5s.225.5.5.5h1c.275 0 .5-.225.5-.5s-.225-.5-.5-.5zM13.5 12h-1c-.275 0-.5.225-.5.5s.225.5.5.5h1c.275 0 .5-.225.5-.5s-.225-.5-.5-.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#21A366",
    d: "M16.5 10h-1c-.275 0-.5.225-.5.5s.225.5.5.5h1c.275 0 .5-.225.5-.5s-.225-.5-.5-.5zM13.5 10h-1c-.275 0-.5.225-.5.5s.225.5.5.5h1c.275 0 .5-.225.5-.5s-.225-.5-.5-.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#33C481",
    d: "M16.5 8h-1c-.275 0-.5.225-.5.5s.225.5.5.5h1c.275 0 .5-.225.5-.5s-.225-.5-.5-.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#21A366",
    d: "M13.5 8h-1c-.275 0-.5.225-.5.5s.225.5.5.5h1c.275 0 .5-.225.5-.5s-.225-.5-.5-.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#107C41",
    d: "M2 16h8a1 1 0 001-1V7a1 1 0 00-1-1H2a1 1 0 00-1 1v8a1 1 0 001 1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M4.606 14l3.707-6H7.15l-3.755 6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M7.373 14L3.667 8h1.162l3.754 6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsx);
export default __webpack_public_path__ + "static/media/xlsx.bdccd850f416bd9562a28077710837ca.svg";
export { ForwardRef as ReactComponent };